// You can write more code here

/* START OF COMPILED CODE */

import TransitionScene from "../core/scenes/TransitionScene";
import TransitionPrefab from "../prefabs/TransitionPrefab";
/* START-USER-IMPORTS */
import { SceneData, SceneId, TransitionSceneData } from '../app-routing';
import { TransitionType } from '../core/enums/TransitionType';
/* END-USER-IMPORTS */

export default class TransitionSceneToScene extends TransitionScene {

  constructor() {
    super("TransitionSceneToScene");

    /* START-USER-CTR-CODE */
    this.transitionType = TransitionType.SceneToScene;
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // transitionPrefab
    const transitionPrefab = new TransitionPrefab(this, 937, 399);
    this.add.existing(transitionPrefab);

    this.transitionPrefab = transitionPrefab;

    this.events.emit("scene-awake");
  }

  private transitionPrefab!: TransitionPrefab;

  /* START-USER-CODE */

  private sceneData!: SceneData;
  private transitionSceneData!: TransitionSceneData;

  init(data: SceneData) {
    super.init(data);

    let transitionDefaults: TransitionSceneData = {
      sourceScene: this.scene.key,
      nextScene: SceneId.Title
    };

    this.transitionSceneData = Object.assign({}, transitionDefaults, data.transitionData);
    this.sceneData = data;
    this.sceneData.transitionData = undefined;

    // this.scene.bringToTop(this);
  }

  create() {
    super.create();
    this.editorCreate();

    this.beginSceneToSceneTransition(this.transitionSceneData, this.transitionPrefab, this.sceneData);

    this.events.on('transitionstart', () => {
      this.transitionPrefab.show();
    });

    this.events.once('transitioncomplete', () => {
      // We need to delay the next transition to the next frame or it won't fire.
      this.time.delayedCall(1, () => {
        // Needed as new scenes being added might end up on top and we always want the transition to be top.
        // this.scene.bringToTop(this);

        this.scene.transition({
          target: this.transitionSceneData.nextScene,
          duration: 1000,
          // moveBelow: true, // <--- this doesn't work as expected as the target scene will still be on top.
          data: this.sceneData
        });

        this.time.delayedCall(100, () => {
          this.transitionPrefab.hide();
        });
      });
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
